import Vue from 'vue'
import AppContainer from '@/utvStore/components/AppContainer'
// import AppCopyright from '@/utvStore/components/AppCopyright'
// import AppHeader from '@/utvStore/components/AppHeader'
import RecommendLpManager from './RecommendLpManager'

export default {
  install(Vue) {
    Vue.component('app-container', AppContainer)
    // Vue.component('app-copyright', AppCopyright)
    // Vue.component('app-header', AppHeader)
    Vue.component('recommend-lp-manager', RecommendLpManager)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/components.js